import React, { useState, useEffect } from "react";
import { Button, Card, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "../utils/api";
import CasinoHome from "./CasinoHome";
import LoginModal from "../userAuth/LoginModal";
import GameCard from "./gamePage/components/GameCard";
import FullPageGame from "./gamePage/dedicated/FullPageGame";

const MiddleContent = () => {
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);
  const [banners, setBanners] = useState([]);
  const [featuredSections, setFeaturedSections] = useState([]);
  const [providers, setProviders] = useState([]);
  const [loadingSettings, setLoadingSettings] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  // Drag/Swipe Logic
  const [dragStart, setDragStart] = useState(null);
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    fetchFrontendSettings();
    fetchProviders();
  }, []);

  const fetchProviders = async () => {
    try {
      const res = await api.get("/providers?limit=100&status=true");
      if (res.data.success) {
        setProviders(res.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch providers", error);
    }
  };

  const fetchFrontendSettings = async () => {
    try {
      const [bannerRes, sectionRes] = await Promise.all([
        api.get("/frontend/banners"),
        api.get("/frontend/featured-sections"),
      ]);
      if (bannerRes.data.success) {
        setBanners(bannerRes.data.data);
      }
      if (sectionRes.data.success) {
        setFeaturedSections(sectionRes.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch frontend settings", error);
    } finally {
      setLoadingSettings(false);
    }
  };

  const handleBannerClick = (banner) => {
    if (dragging) return; // Prevent click if we were dragging
    if (banner.linkType === "game" && banner.game) {
      navigate(`/casino/${banner.game.slug}`);
    } else if (banner.linkType === "custom" && banner.customLink) {
      if (banner.customLink.startsWith("/")) {
        navigate(banner.customLink);
      } else {
        window.location.href = banner.customLink;
      }
    }
  };

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const onTouchStart = (e) => {
    setDragStart(e.touches ? e.touches[0].clientX : e.clientX);
    setDragging(false);
  };

  const onTouchMove = (e) => {
    if (dragStart === null) return;
    const currentX = e.touches ? e.touches[0].clientX : e.clientX;
    const diff = dragStart - currentX;

    if (Math.abs(diff) > 5) {
      setDragging(true);
    }
  };

  const onTouchEnd = (e) => {
    if (dragStart === null) return;
    const currentX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const diff = dragStart - currentX;
    const threshold = 50;

    if (diff > threshold) {
      // Next
      setActiveIndex((prev) => (prev + 1) % banners.length);
    } else if (diff < -threshold) {
      // Prev
      setActiveIndex((prev) => (prev - 1 + banners.length) % banners.length);
    }

    setDragStart(null);
    setTimeout(() => setDragging(false), 50);
  };

  const handleGameClick = (game) => {
    navigate(`/casino/${game.slug}`);
  };

  return (
    <div className="middle-content">
      <FullPageGame gameId="699ca6f11df7e8e66f587d97" pageTitle="Lucky Games" />
      <style>
        {`
          .banner-carousel .carousel-control-prev,
          .banner-carousel .carousel-control-next {
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(8px);
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
            margin: 0 10px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;
            opacity: 0.8;
          }
          .banner-carousel .carousel-control-prev:hover,
          .banner-carousel .carousel-control-next:hover {
            background: rgba(255, 153, 0, 0.8);
            border-color: #ff9900;
            opacity: 1;
            transform: translateY(-50%) scale(1.1);
          }
          .banner-carousel .carousel-control-prev-icon,
          .banner-carousel .carousel-control-next-icon {
            width: 20px;
            height: 20px;
          }
          .banner-carousel .carousel-indicators {
            bottom: 5px;
          }
          .banner-carousel .carousel-indicators [data-bs-target] {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #ff9900;
            border: none;
            box-shadow: 0 0 5px rgba(0,0,0,0.5);
          }
          /* Prevent text selection during drag */
          .banner-carousel {
            user-select: none;
            -webkit-user-drag: none;
          }

          .providers-slider-container {
            display: flex;
            overflow-x: auto;
            gap: 15px;
            padding: 10px 5px;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none;  /* IE and Edge */
          }
          .providers-slider-container::-webkit-scrollbar {
            display: none; /* Chrome, Safari and Opera */
          }
          .provider-slide-card {
            min-width: 100px;
            height: 60px;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            flex-shrink: 0;
            padding: 8px;
          }
          .provider-slide-card:hover {
            background: rgba(255, 153, 0, 0.15);
            border-color: #ff9900;
            transform: translateY(-3px);
          }
          .provider-slide-logo {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            filter: grayscale(1) brightness(1.5);
            transition: all 0.3s ease;
          }
          .provider-slide-card:hover .provider-slide-logo {
            filter: grayscale(0) brightness(1);
          }
          .provider-slide-name {
            font-size: 0.75rem;
            font-weight: 600;
            color: #aaa;
            text-align: center;
          }
        `}
      </style>
      {/* <div className="scroll-content px-2"> */}
      {/* Banner Slider */}
      {/* {banners.length > 0 && (
          <div
            onMouseDown={onTouchStart}
            onMouseMove={onTouchMove}
            onMouseUp={onTouchEnd}
            onMouseLeave={() => setDragStart(null)}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <Carousel
              fade
              interval={dragging ? null : 3000} // Pause auto-slide while dragging
              activeIndex={activeIndex}
              onSelect={handleSelect}
              controls={banners.length > 1}
              indicators={banners.length > 1}
              pause="hover"
              className="mb-3 rounded overflow-hidden banner-carousel"
            >
              {banners.map((banner, index) => (
                <Carousel.Item key={banner._id || index} onClick={() => handleBannerClick(banner)} style={{ cursor: "pointer" }}>
                  <Card className="bg-dark text-light border-0">
                    <Card.Img
                      variant="top"
                      src={banner.useGameThumbnail ? banner.game?.thumbnail : banner.image}
                      style={{ height: "250px", objectFit: "cover", pointerEvents: "none" }}
                      alt={banner.title}
                    />
                    {banner.title && (
                      <Carousel.Caption style={{
                        background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        padding: "20px 10px 30px 10px",
                        textAlign: "center"
                      }}>
                        <h5 className="m-0" style={{ fontSize: "1.1rem", fontWeight: "600" }}>{banner.title}</h5>
                      </Carousel.Caption>
                    )}
                  </Card>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        )} */}

      {/* Providers Slider */}
      {providers.length > 0 && (
        <div className="mb-4 mt-2">
          <div className="providers-slider-container">
            {providers.map((p) => (
              <div
                key={p._id}
                className="provider-slide-card"
                onClick={() => navigate(`/providers/${p.slug}`)}
              >
                {p.logo && p.logo.trim() !== "" ? (
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="provider-slide-logo"
                  />
                ) : (
                  <span className="provider-slide-name text-uppercase">
                    {p.name}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {banners.length > 0 && (
        <div
          onMouseDown={onTouchStart}
          onMouseMove={onTouchMove}
          onMouseUp={onTouchEnd}
          onMouseLeave={() => setDragStart(null)}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <Carousel
            fade
            interval={dragging ? null : 3000} // Pause auto-slide while dragging
            activeIndex={activeIndex}
            onSelect={handleSelect}
            controls={banners.length > 1}
            indicators={banners.length > 1}
            pause="hover"
            className="mb-3 rounded overflow-hidden banner-carousel"
          >
            {banners.map((banner, index) => (
              <Carousel.Item
                key={banner._id || index}
                onClick={() => handleBannerClick(banner)}
                style={{ cursor: "pointer" }}
              >
                <Card className="bg-dark text-light border-0">
                  <Card.Img
                    variant="top"
                    src={
                      banner.useGameThumbnail
                        ? banner.game?.thumbnail
                        : banner.image
                    }
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      pointerEvents: "none",
                    }}
                    alt={banner.title}
                  />
                  {banner.title && (
                    <Carousel.Caption
                      style={{
                        background:
                          "linear-gradient(transparent, rgba(0,0,0,0.8))",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        padding: "20px 10px 30px 10px",
                        textAlign: "center",
                      }}
                    >
                      <h5
                        className="m-0"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        {banner.title}
                      </h5>
                    </Carousel.Caption>
                  )}
                </Card>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      )}
      {/* Featured Sections - Moved here after Banner Slider */}
      {featuredSections.map((section) => (
        <div key={section._id} className="mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="m-0 fw-bold text-white px-1">
              <span
                style={{
                  borderLeft: "4px solid #ff9900",
                  paddingLeft: "10px",
                }}
              >
                {section.title}
              </span>
            </h5>
            <Button
              size="sm"
              variant="outline-warning"
              style={{ fontSize: "0.7rem" }}
            >
              VIEW ALL
            </Button>
          </div>

          <div
            className="game-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
              gap: "15px",
            }}
          >
            {section.games
              ?.filter((g) => g !== null)
              .map((game) => (
                <div
                  key={game._id}
                  onClick={() => handleGameClick(game)}
                  style={{ cursor: "pointer" }}
                >
                  <GameCard game={game} />
                </div>
              ))}
          </div>
        </div>
      ))}

      {/* <CasinoHome /> */}

      {/* Configure LoginModal */}
      <LoginModal show={showLogin} handleClose={() => setShowLogin(false)} />
    </div>
    // </div>
  );
};

export default MiddleContent;
